module.exports = __webpack_public_path__ + "926c93d201fe51c8f351e858468980c3.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.6.1
 ** module id = 115
 ** module chunks = 0
 **/